import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
  SuccessHttpResponse,
} from '../../../models/https';
import { jobCreatedListActions } from '../../../redux/slices/jobCreatedListSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

interface CreatedJobsFilter {
  page?: string;
  perPage?: string;
  keyword?: string;
}

const useGetCreatedJobPosts = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetCreatedJobPostsError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching created job posts'
    );
  };

  const getCreatedJobPosts = useCallback(
    (filter?: CreatedJobsFilter, userId?: string) => {
      // Extract pagination values from the filter or use defaults
      const page = parseInt(filter?.page ?? '1', 10);
      const perPage = parseInt(filter?.perPage ?? '10', 10);

      // Compute offset (0-indexed) from the page number (which is 1-indexed)
      // const offset = Math.max(page - 1, 0);

      // Build the URL using the offset, perPage, and the userId as a query parameter.
      let urlPath = `jobs-service/jobs/me/created/?offset=${page}&limit=${perPage}`;

      // Append search query parameters if provided
      if (filter?.keyword) {
        urlPath += `&keyword=${encodeURIComponent(filter.keyword)}`;
      }

      const url: HttpConfig = {
        url: urlPath,
        method: 'get',
      };

      const onGetCreatedJobPostsSuccess = (
        response: SuccessHttpResponse<PaginatedResponse>
      ) => {
        // Extract the paginated response from the data property.
        const paginatedData = response.data;
        console.log('Created jobs response:', paginatedData);
        const {
          totalPages,
          totalElements,
          numberOfElements,
          first,
          last,
          content,
        } = paginatedData;

        dispatch(
          jobCreatedListActions.getJobCreatedList({
            page, // original page number for UI purposes
            perPage,
            totalPages,
            totalElements,
            numberOfElements,
            first,
            last,
            jobData: Array.isArray(content) ? content : [],
          })
        );
      };

      return request(
        url,
        onGetCreatedJobPostsSuccess,
        setLoading,
        onGetCreatedJobPostsError
      );
    },
    [dispatch, request]
  );

  return { getCreatedJobPosts, loading };
};

export default useGetCreatedJobPosts;
